if ($('#app-ott-form').length) {

    form_validator('#app-ott-form',
        {
            requestor_name: {
                required: true
            },
            requestor_email: {
                required: true
            },
            // return_date: {
            //     required: true
            // },
            // presentation_date: {
            //     required: true
            // },
            client_name: {
                required: true
            },
            client_budget: {
                required: true
            },
            product: {
                required: false
            },
            // proposal_start: {
            //     required: true
            // },
            // proposal_end: {
            //     required: true
            // },
        },
        {
            campaign_name: "Please define the requestor's name.",
            campaign_budget: "Please type the requestor's email.",
            // return_date: "Please define the RFP returns date.",
            // presentation_date: "Please define the presentation date.",
            client_name: "Please select the client name.",
            client_budget: "Please select the client budget.",
           // product: "Please select a Product.",
            // proposal_start: "Proposal start date is required.",
            // proposal_end: "Proposal end date is required.",

        }
    );
    $('#li_tab_1').removeClass('ms-hover');
    $('#li_tab_2').removeClass('ms-hover');

    $('#client_name').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 3
    });
    $('#product').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 3
    });

    $('#brand').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 3
    });

    var input = $("#return_date");

    if (input.data('datepicker')) {
        input.datepicker('remove');
    }

    input.datepicker({
        format: "mm/dd/yyyy",
        autoclose: true,
        clearBtn: false,
        orientation: "bottom",
    });

    var input = $("#presentation_date");

    if (input.data('datepicker')) {
        input.datepicker('remove');
    }

    input.datepicker({
        format: "mm/dd/yyyy",
        //  startView: "months",
        //  minViewMode: "months",
        autoclose: true,
        clearBtn: false,
        orientation: "bottom"
    });

    var input = $("#proposal_start");

    if (input.data('datepicker')) {
        input.datepicker('remove');
    }

    input.datepicker({
        format: "mm/dd/yyyy",
        autoclose: true,
        clearBtn: false,
        orientation: "bottom"
    });

    var input = $("#proposal_end");

    if (input.data('datepicker')) {
        input.datepicker('remove');
    }

    input.datepicker({
        format: "mm/dd/yyyy",
        autoclose: true,
        clearBtn: false,
        orientation: "bottom"
    });

    $('#zip_code').select2({
        tags: true,
        minimumResultsForSearch: Infinity,
        placeholder: ""
    });

    $('#client_name').on('change', function () {
        show_loader();
        var adv_id = $('#client_name option:selected').val();
        $.ajax({
            type: 'GET',
            url: '/ott/integration/get/adv/data/' + adv_id ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#client_site').val(data.web_site);
                $('#client_contact_email').val(data.email);
                var html = '<option></option>';
                for(var i in data.products)
                    html += '<option value="'+ i +'">'+ data.products[i] +'</option>';
                $('#product').html(html);

                var html ='';
                for(var i in data.brands)
                    html += '<option value="'+ i +'">'+ data.brands[i] +'</option>';
                $('#brand').html(html);

                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    $('#add_product').on('click', function () {
        if($('#client_name option:selected').val() == ''){
            $('#generalWarningModalDiv').html('Please select a Client first.');
            $('#generalWarningModal').modal('show');
        }
        else
            $('#addProductModal').modal('show');

    });

    $('#add_brand').on('click', function () {
        $('#addBrandModal').modal('show');

    });

    $('#add_new_brand').on('click', function () {
        if($('#new_brand').val() == ''){
            $('#generalWarningModalDiv').html('Brand Field is required.');
            $('#generalWarningModal').modal('show');
        }
        else {
            show_overlay_loader($('#addBrandModal .modal-content'));
            var adv_id = $('#client_name option:selected').val();
            var  params = {
                adv_id: adv_id,
                brand_name: $('#new_brand').val(),
            }
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/ott/integration/add/new/brand',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var html = ''
                    html = '<option value="' + data.id + '"> ' + data.name + ' </option>';
                    $('#brand').html(html);
                    $('#addBrandModal').modal('hide');
                    hide_overlay_loader($('#addBrandModal .modal-content'));
                },
                error: function (xhr) {
                    hide_overlay_loader($('#addBrandModal .modal-content'));
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }

    });

    $('#save_product').on('click', function () {
       if( $('#brand').val() == ''){
           $('#generalWarningModalDiv').html('Please select a Brand first.');
           $('#generalWarningModal').modal('show');
       }
        else if( $('#new_product').val() == ''){
            $('#generalWarningModalDiv').html('Please define the New Product Name.');
            $('#generalWarningModal').modal('show');
        }
        else{
           show_overlay_loader($('#addProductModal .modal-content'));
           var  params = {
               brand_id: $('#brand').val(),
               product_name: $('#new_product').val(),
           }
           $.ajax({
               type: 'POST',
               headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
               data: JSON.stringify(params),
               url: '/ott/integration/add/new/product',
               dataType: "json",
               contentType: "application/json",
               success: function (data) {
                   var html = ''
                   html = '<option value="' + data.id + '" selected> ' + data.name + ' </option>';
                   $('#product').append(html);
                   $('#addProductModal').modal('hide');
                   hide_overlay_loader($('#addProductModal .modal-content'));
               },
               error: function (xhr) {
                   hide_overlay_loader($('#addProductModal .modal-content'));
                   ajax_error();
                   debug(xhr.responseText);
               }
           });
       }
    });

    $('.wizard-active-tab1').on('click', function () {
        active_tab_1();
    });

    $('.wizard-active-tab2').on('click', function () {
        active_tab_2();
    });

    $('.wizard-previous').on('click', function () {
        active_tab_1();
    });

    $('.wizard-next').on('click', function () {
        active_tab_2();
    });

    function active_tab_1() {
        if ($('#tab2').hasClass('active')) {

            $('#tab1').addClass('active');
            $('#tab1').addClass('content-current');
            $('.li_tab_1').addClass('active');
            $('.li_tab_1').addClass('tab-current');
            $('.wizard-active-tab1').attr('aria-expanded', true);

            $('#tab2').removeClass('active');
            $('#tab1').removeClass('content-current');
            $('.li_tab_2').removeClass('active');
            $('.li_tab_2').removeClass('tab-current');
            $('.wizard-active-tab2').removeAttr('aria-expanded');

            $('.wizard-previous').hide();
            $('.wizard-finish').hide();
            $('.wizard-next').show();
        }
    }

    function active_tab_2() {
        $('.zip_code .search-icon-input').hide();
        if ($('#tab1').hasClass('active')) {
            var text = '';
            if($('#requestor_name').val() == '')
                text += 'Please define the Requestor name.<br>' + ' \n';

            if($('#requestor_email').val() == '')
                text += 'Please define the Requestor email.<br>' + ' \n';

            if($('#client_name option:selected').val() == '')
                text += 'Please select a Client.<br>' + ' \n';

            if($('#client_budget').val() == '')
                text += 'Please define a Client Budget.<br>' + ' \n';


            if(text !== '') {
                var $valid = $('#app-ott-form').valid();
                var $validator = form_validator('#app-ott-form');
                if (!$valid)
                    $validator.focusInvalid();
                $('#generalWarningModalDiv').html(text);
                $('#generalWarningModal').modal('show');
            }
            else {
                $('#tab1').removeClass('active');
                $('#tab1').removeClass('content-current');
                $('.li_tab_1').removeClass('active');
                $('.li_tab_1').removeClass('tab-current');
                $('.wizard-active-tab1').removeAttr('aria-expanded');

                $('#tab2').addClass('active');
                $('#tab1').addClass('content-current');
                $('.li_tab_2').addClass('active');
                $('.li_tab_2').addClass('tab-current');
                $('.wizard-active-tab2').attr('aria-expanded', true);

                $('.wizard-previous').show();
                $('.wizard-finish').show();
                $('.wizard-next').hide();
            }
        }
    }

    $('.wizard-finish').on('click', function () {
        show_loader();
        var text = '';
        if($('#requestor_name').val() == '')
            text += 'Please define the Requestor name.<br>' + ' \n';

        if($('#requestor_email').val() == '')
            text += 'Please define the Requestor email.<br>' + ' \n';

        if($('#client_name option:selected').val() == '')
            text += 'Please select a Client.<br>' + ' \n';

        if($('#client_budget').val() == '')
            text += 'Please define a Client Budget.<br>' + ' \n';

        if(text !== '') {
            var $valid = $('#app-ott-form').valid();
            var $validator = form_validator('#app-ott-form');
            if (!$valid)
                $validator.focusInvalid();
            $('#generalWarningModalDiv').html(text);
            $('#generalWarningModal').modal('show');
            hide_loader();
        }
        else
            $('#app-ott-form').submit();

    });

}

if ($('#app-ott-table').length) {
    var global_view_type = 1;
    var data_table_order = [0, "desc"];
    initializeOTTTable();

    function initializeOTTTable(range = "") {
        $('#app-ott-table').DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
                url: '/digital/ott/list',
                dataSrc: 'data',
            },
            order: [6, "desc"],
            columns: [
                {data: 'ott_id'},//0
                {data: 'requestor_name'},//1
                {data: 'requestor_email'},//2
                {data: 'advertiser_name'},//3
                {data: 'client_budget'},//4
                {data: 'product_name'},//5
                {data: 'sent_at'},//6
                {data: 'user_name'},//7
                {data: 'ott_id'},//8
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 3,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 6,
                    "orderable": false,
                },
                {
                    "targets": 5,
                    "orderable": false,
                },
                {
                    "targets": 0,
                    "orderable": false,
                    "className": "text-left",
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = ' <div class="checkbox checkbox-danger ott_check_table"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.ott_id + '" name="selected_ott[]" value="' + rowData.ott_id + '" ><label for="' + rowData.ott_id + '"> </label></div>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 8,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        html = '<div class="row text-center " style="">';
                        html += '<div class="btn-group " role="group" >';
                        html += ' <button class="btn btn-info btn-outline btn-sm download_line " type="button"  data-id="' + rowData.ott_id + '"><i class="fa fa-download"></i> Download </button> ';
                        html += ' <button class="btn btn-primary btn-outline btn-sm delete_line" type="button"  data-id="' + rowData.ott_id + '"><i class="fa fa-trash-o"></i> Delete </button> ';
                        html += '</div>';
                        html += '</div>';

                        $(td).html(html);
                    }
                },
            ]
        });
    }

    $('#app-ott-table').on('length.dt', function (e, settings, len) {
        user_entries = len;
    });
    $('#app-ott-table').on('order.dt', function (e, settings, len) {
        data_table_order = [len[0].col, "" + len[0].dir + ""];
    });

    //Select/Descelect all
    $('#select_all_ott').on('click', function (e) {
        $('#app-ott-table input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_ott').on('click', function (e) {
        $('#app-ott-table input:checkbox').prop('checked', false);
    });

    $('#app-ott-table').on('click', '.delete_line', function () {
        show_loader()
        var ott_id = $(this).attr('data-id');
        var params = {
            ott_id : [ott_id],
        };
        delete_request(params);
    });

    $('#delete_form_ott').on('click', function () {
        show_loader();
        var selectedItems = [];
        $('.ott_check_table input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if(selectedItems.length > 0){
            var params = {
                ott_id : selectedItems,
            };
            delete_request(params)
        }
        else{
            hide_loader();
            $('#generalWarningModalDiv').html('Please select a Proposal Request first.');
            $('#generalWarningModal').modal('show');
        }
    });

     function delete_request(params) {
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/ott/integration/delete/form',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                hide_loader();
                $('#app-ott-table').DataTable().ajax.reload();
                global_notification('success', 'Proposal Request Form deleted...')
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    $('#app-ott-table').on('click', '.download_line', function(){
        show_loader();
        var ott_id = $(this).attr('data-id');
        $.ajax({
            type: 'GET',
            url: '/ott/integration/download/form/' + ott_id ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var a = document.createElement('a');
                var data_type = 'data:application/vnd.ms-excel';
                a.href = data_type + ', ' + encodeURIComponent(data);
                a.download = 'proposal-request-fomr.xls';
                a.click();

                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });

    });
}
